"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraTable = void 0;
var _core = require("@material-ui/core");
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableContainer = _interopRequireDefault(require("@material-ui/core/TableContainer"));
var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _styles = require("@material-ui/styles");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _MoreHoriz = _interopRequireDefault(require("@material-ui/icons/MoreHoriz"));
var _pittaModules = require("@thingsw/pitta-modules");
var _Fonts = require("../constants/Fonts");
var _IconButton = require("./IconButton");
var _Typography = require("./Typography");
var _CameraInfoRev = require("./CameraInfoRev");
var _clsx4 = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CAMERA_HEADERS = ["Camera", "Firmware", "Group", "Driver"];
var TableHeaderCell = (0, _styles.withStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: _objectSpread({
      padding: theme.spacing(1),
      paddingBottom: 11
    }, theme.direction === "rtl" ? {
      textAlign: "right"
    } : {
      textAlign: "left"
    }),
    //@ts-ignore
    head: _objectSpread(_objectSpread({}, _Fonts.Fonts.Default.Small), {}, {
      color: _pittaModules.LightColors.primary["2"]
    })
  });
})(_TableCell.default);
var TableCell = (0, _styles.withStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: _objectSpread({
      padding: theme.spacing(1.5, 1, 0.875),
      width: "25%"
    }, theme.direction === "rtl" ? {
      textAlign: "right"
    } : {
      textAlign: "left"
    }),
    //@ts-ignore
    body: _objectSpread(_objectSpread({}, _Fonts.Fonts.Default.Body), {}, {
      color: _pittaModules.LightColors.primary["1"],
      verticalAlign: "top"
    })
  });
})(_TableCell.default);
var useStyles = (0, _core.makeStyles)(function () {
  return {
    moreDiv: {
      width: 24
    },
    moreBtn: {
      padding: 0
    },
    rowHover: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "".concat(_pittaModules.LightColors.primary["6"], "!important")
      }
    },
    fwDiv: {
      minHeight: 50
    },
    disabled: {
      opacity: 0.35
    }
  };
});
var CameraTable = function CameraTable(_ref) {
  var cameras = _ref.cameras,
    _onClick = _ref.onClick,
    onClickMore = _ref.onClickMore,
    t = _ref.t,
    cameraTableIcon = _ref.cameraTableIcon;
  var classes = useStyles();
  var buttonsRef = (0, _react.useRef)(_lodash.default.map(cameras, function () {
    return /*#__PURE__*/(0, _react.createRef)();
  }));
  var renderTable = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement(_TableContainer.default, null, /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-label": "simple table"
    }, /*#__PURE__*/_react.default.createElement(_TableHead.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, _lodash.default.map(CAMERA_HEADERS, function (header) {
      return /*#__PURE__*/_react.default.createElement(TableHeaderCell, {
        style: {
          width: "25%"
        },
        key: header
      }, t(header));
    }), /*#__PURE__*/_react.default.createElement(TableHeaderCell, {
      className: classes.moreDiv
    }))), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, _lodash.default.map(cameras, function (cam, index) {
      var _t, _cam$groupName, _cam$driverName;
      return /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: cam.valid !== "invalid",
        key: "camera-".concat(index),
        classes: {
          hover: classes.rowHover
        },
        onClick: function onClick() {
          // mantis - 12405, 비활성화 Cloud camera 비활성화처리되면 클릭 작동하지 않도록 적용 (Leehj)
          if (cam.valid !== "invalid") {
            _onClick === null || _onClick === void 0 ? void 0 : _onClick(cam);
          }
        }
      }, /*#__PURE__*/_react.default.createElement(TableCell, {
        component: "th",
        scope: "row"
      }, /*#__PURE__*/_react.default.createElement(_CameraInfoRev.CameraInfoRev, {
        camera: cam,
        dense: true,
        cameraTableIcon: cameraTableIcon
        // mantis - 12405, 비활성화 Cloud camera 비활성화처리 (Leehj)
        ,
        disabled: cam.valid === "invalid"
      })), /*#__PURE__*/_react.default.createElement(TableCell, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _clsx4.default)(classes.fwDiv, _defineProperty({}, classes.disabled, cam.valid === "invalid"))
      }, !cam.fw_ver || cam.fw_ver === "" ? "–" : cam.fw_ver, /*#__PURE__*/_react.default.createElement("br", null), cam.newFw && /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
        category: "Default",
        variant: "Caption",
        htmlColor: _pittaModules.LightColors.secondary["11"]
      }, (_t = t("Update available")) !== null && _t !== void 0 ? _t : "Update available"))), /*#__PURE__*/_react.default.createElement(TableCell
      // mantis - 12405, 비활성화 Cloud camera 비활성화처리 (Leehj)
      , {
        className: (0, _clsx4.default)(_defineProperty({}, classes.disabled, cam.valid === "invalid"))
      }, (_cam$groupName = cam.groupName) !== null && _cam$groupName !== void 0 ? _cam$groupName : "–"), /*#__PURE__*/_react.default.createElement(TableCell
      // mantis - 12405, 비활성화 Cloud camera 비활성화처리 (Leehj)
      , {
        className: (0, _clsx4.default)(_defineProperty({}, classes.disabled, cam.valid === "invalid"))
      }, (_cam$driverName = cam.driverName) !== null && _cam$driverName !== void 0 ? _cam$driverName : "–"), /*#__PURE__*/_react.default.createElement(TableCell, {
        className: classes.moreDiv,
        style: {
          position: "relative"
        }
      }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
        ref: buttonsRef.current[index],
        className: classes.moreBtn,
        color: "secondary",
        onClick: function onClick(e) {
          e.stopPropagation();
          onClickMore(cam, buttonsRef.current[index]);
        }
        // mantis - 12405, 비활성화 Cloud camera 비활성화처리 (Leehj)
        ,
        disabled: cam.valid === "invalid"
      }, /*#__PURE__*/_react.default.createElement(_MoreHoriz.default, null)), (cam.newFw || cam.require_time_sync) && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: 6,
          height: 6,
          borderRadius: 3,
          backgroundColor: _pittaModules.LightColors.secondary["11"],
          position: "absolute",
          top: 10,
          right: 5
        }
      })));
    }))));
  }, [classes.moreDiv, classes.rowHover, classes.fwDiv, classes.disabled, classes.moreBtn, cameras, t, cameraTableIcon, _onClick, onClickMore]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderTable());
};
exports.CameraTable = CameraTable;